import storage from '@services/storage'

window.dataLayer = window.dataLayer || []

const debug = storage.getItem('da.dashboard.debug.ga')

export default {
  install: Vue => {
    Vue.ga = {
      send(prefix = 'event', {
        hitType = undefined,
        category = undefined,
        action = undefined,
        label = undefined,
        value = undefined,
      } = {}) {
        const payload = {
          hitType,
          eventCategory: category,
          eventAction: `${prefix}_${action}`,
          eventLabel: label,
          eventValue: value,
        }

        if (window.ga) {
          window.ga('send', 'event', payload)
        }

        if (debug) {
          console.log('send', 'event', payload)
        }
      },
      event(data) {
        this.send('event', data)
      },
      action(data) {
        this.send('action', data)
      },
      view(data) {
        this.send('view', data)
      },
    }
    Vue.prototype.$ga = Vue.ga
  },
}
